var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupComputerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#E1E9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 35C11.2891 35 10.9726 34.872 10.7175 34.616C10.4615 34.3609 10.3335 34.0444 10.3335 33.6667C10.3335 33.2889 10.4615 32.9724 10.7175 32.7173C10.9726 32.4613 11.2891 32.3333 11.6668 32.3333H38.3335C38.7113 32.3333 39.0277 32.4613 39.2828 32.7173C39.5388 32.9724 39.6668 33.2889 39.6668 33.6667C39.6668 34.0444 39.5388 34.3609 39.2828 34.616C39.0277 34.872 38.7113 35 38.3335 35H11.6668ZM14.3335 31C13.6002 31 12.9726 30.7391 12.4508 30.2173C11.9282 29.6947 11.6668 29.0667 11.6668 28.3333V13.6667C11.6668 12.9333 11.9282 12.3053 12.4508 11.7827C12.9726 11.2609 13.6002 11 14.3335 11H35.6668C36.4002 11 37.0282 11.2609 37.5508 11.7827C38.0726 12.3053 38.3335 12.9333 38.3335 13.6667V28.3333C38.3335 29.0667 38.0726 29.6947 37.5508 30.2173C37.0282 30.7391 36.4002 31 35.6668 31H14.3335ZM14.3335 28.3333H35.6668V13.6667H14.3335V28.3333ZM14.3335 28.3333V13.6667V28.3333Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupComputerIcon);
export default __webpack_public_path__ + "static/media/GroupComputerIcon.8d4cf05d02b74cf5f98ece40daa2d65d.svg";
export { ForwardRef as ReactComponent };